import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  bankIdAisHeading: {
    id: 'Payments.bankIdAISHeading',
    defaultMessage: 'Confirm your identity',
  },
  bankIdPisHeading: {
    id: 'Payments.bankIdPISHeading',
    defaultMessage: 'Confirm your payment',
  },
});
